var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('ERow',[_c('ECol',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('AuditLogsTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }